// Module
var code = "<div class=stacked-bar-chart> <h3 class=chart-title translate>{{$scope.context.configs.chartTitle}}</h3> <div class=stacked-bar-chart-content></div> <div class=stacked-bar-legend-container> <div class=stacked-bar-chart-legend></div> </div> </div>";
// Exports
module.exports = code;